import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {
  AccentButton,
  Icon,
  SquareBorderButton,
  ActivityIndicator
} from '@lyearn-team/frontend-components';
import CopyToClipboard from 'react-copy-to-clipboard';
import { withTheme } from 'emotion-theming';
import Certificate from './Certificate';
import styles from './styles';

const TEMPLATE_BASE_HEIGHT = 750;
const TEMPLATE_BASE_WIDTH = 1030;

@withTheme
class CertificatePreview extends Component {
  constructor(props) {
    super(props);
    if (!this.certificateNode) {
      this.certificateNode = document.createElement('div');
      this.certificateNode.id = 'certificate-node';
      document.body.appendChild(this.certificateNode);
    }

    this.state = {
      active: 'none',
      copied: false,
      downloadOpened: false
    };
    const windowHeight = window.innerHeight;
    const availableHeight = windowHeight * 0.75;
    const templateHeight = Math.max(availableHeight, TEMPLATE_BASE_HEIGHT);
    this.ratio = availableHeight / templateHeight;
    this.tabWidth = this.ratio * TEMPLATE_BASE_WIDTH;
  }

  renderCertificateActions = () => {
    if (!this.props.renderActions) {
      return null;
    }
    const { certificateSettings } = this.props;
    const tabs = [
      {
        text: 'Add to LinkedIn',
        onClick: this.changeActiveTab('linkedin'),
        name: 'linkedin',
        icon: true
      },
      {
        text: 'Share Certificate',
        onClick: this.changeActiveTab('forward'),
        name: 'forward',
        icon: true
      },
      {
        text: 'Download PDF',
        onClick: this.changeActiveTab('download'),
        name: 'download',
        icon: false
      }
    ];
    if (certificateSettings && certificateSettings.dontPublishOnLinkedIn) {
      tabs.splice(0, 1);
    }
    const white = this.props.theme.color.white;
    return (
      <div className={styles.tabWrapper()}>
        {tabs.map(tab => (
          <div>
            <AccentButton
              onClick={tab.onClick}
              text={tab.text}
              icon={{
                type: tab.name,
                style: { width: '18px', height: '24px', marginRight: '7px', fill: white }
              }}
              style={{ color: white }}
            />
            {tab.icon ? (
              <Icon
                type={this.getActiveTabIcon(tab.name)}
                style={{
                  marginRight: '30px',
                  height: '24px',
                  verticalAlign: 'baseline',
                  marginLeft: '8px',
                  fill: white
                }}
              />
            ) : null}
          </div>
        ))}
        ;
      </div>
    );
  };

  getActiveTabIcon = name => {
    const { active } = this.state;
    if (active === name) {
      return 'angle-up';
    }
    return 'angle-down';
  };

  redirectToLinkedin = () => {
    window.open('https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME', '_blank');
  };

  renderOpenTab = () => {
    if (!this.props.renderActions) {
      return null;
    }
    const { active, copied, downloadOpened } = this.state;
    const { certificateDetails } = this.props;
    if (active === 'linkedin') {
      return this.renderLinkedinTab(certificateDetails);
    }
    if (active === 'forward') {
      const link = certificateDetails.url;
      const buttonText = copied ? 'Copied' : 'Copy Link';
      return this.renderShareTab(link, buttonText);
    }

    if (active === 'download' && !downloadOpened) {
      const iframe = document.getElementById('certificateIframe');
      const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
      const head = innerDoc.head || document.getElementsByTagName('head')[0];

      if (!head.hasChildNodes('style')) {
        const previewStyle = document.createElement('style');
        previewStyle.appendChild(
          document.createTextNode(`
          @font-face {
            font-family: 'ProximaNova';
            src: local('ProximaNova Regular'), local('ProximaNova-Regular'), url(https://dndw32r4edmw5.cloudfront.net/assets/frontend-js/fonts/proximanova/proximanova-regular.otf) format('truetype');
          }
          @page { size: 279mm 221mm; margin: 5mm; }
          html,body{
            width: 297mm;
            height: 210mm;
            margin: 4mm auto;
          }
          .certificateContainer{
            margin: auto;
          }`)
        );

        head.appendChild(previewStyle);
      }
      document.getElementById('certificateIframe') &&
        document.getElementById('certificateIframe').contentWindow.print();
      this.setState({
        downloadOpened: true
      });
    }
    return null;
  };

  changeActiveTab = activeTab => () => {
    const { active } = this.state;
    let newActive = activeTab;
    if (active === activeTab && activeTab !== 'download') {
      newActive = 'none';
    }
    if (activeTab === 'download') {
      this.setState({
        downloadOpened: false
      });
    }
    this.setState({
      active: newActive
    });
  };

  renderClose = () => (
    <AccentButton
      onClick={this.changeActiveTab('none')}
      icon={{
        type: 'close',
        style: { width: '14px', height: '14px', fill: this.props.theme.color.black3 },
        scale: 1.2
      }}
      style={{ position: 'absolute', right: '12px', top: '12px', cursor: 'pointer' }}
    />
  );

  renderLinkedinTab = certificate => {
    const theme = this.props.theme;
    const fields = [
      {
        text: 'Certification name:',
        key: 'activityTitle'
      },
      {
        text: 'Certification authority:',
        key: 'company'
      },
      {
        text: 'License number:',
        key: 'number'
      },
      {
        text: 'Issue Date:',
        key: 'from'
      },
      {
        text: 'Expiration Date:',
        key: 'to'
      },
      {
        text: 'Certification URL:',
        key: 'url'
      }
    ];
    return (
      <div className={styles.tabInnerWrapper(theme, this.tabWidth)}>
        {this.renderClose()}
        <div onClick={this.changeActiveTab('none')} role="presentation" />
        <p className={styles.tabInnerHeader(theme)}>Add to LinkedIn</p>
        <p className={styles.tabInnerInstruction(theme)}>
          Enter the following in the
          <AccentButton
            text="Add certification section in LinkedIn: "
            style={{ marginLeft: '5px' }}
            onClick={this.redirectToLinkedin}
          />
        </p>
        {fields.map(field => (
          <div className={styles.tabInnerDetails()}>
            <p className={styles.tabInnerDetailsContent(theme)}>{field.text}</p>
            <p className={styles.tabInnerDetailsContent(theme, field.key === 'number')}>
              {certificate[field.key]}
            </p>
          </div>
        ))}
      </div>
    );
  };

  renderShareTab = (link, buttonText) => {
    const theme = this.props.theme;
    return (
      <div className={styles.tabInnerWrapper(theme, this.tabWidth)}>
        {this.renderClose()}
        <p className={styles.tabInnerHeader(theme)}>Share Certificate</p>
        <p className={styles.tabInnerInstruction(theme)}>
          Copy and paste the link below to share this certificate:{' '}
        </p>
        <div style={{ display: 'flex' }}>
          <p className={styles.linkStyle(theme)}>{link}</p>
          <CopyToClipboard text={link} onCopy={() => this.setState({ copied: true })}>
            <SquareBorderButton
              size="large"
              type="filled"
              onClick={() => {}}
              text={buttonText}
              style={{ marginLeft: '20px' }}
            />
          </CopyToClipboard>
        </div>
      </div>
    );
  };

  renderCertificatePreview = () => {
    const { loading, theme, ...restProps } = this.props;
    const { active } = this.state;
    const isOpen = !['none', 'download'].includes(active);

    if (loading) {
      return (
        <div className={styles.previewContainer(theme, loading)}>
          <ActivityIndicator svgColor="white" />
        </div>
      );
    }

    const style = {
      transform: `scale(${this.ratio})`,
      transformOrigin: 'center center',
      backgroundColor: 'rgb(255, 255, 255)',
      position: 'relative'
    };

    return (
      <div
        className={styles.previewContainer(theme)}
        onClick={event => event.stopPropagation()}
        role="button"
        tabIndex="0"
      >
        {this.renderCertificateActions()}
        {this.renderOpenTab()}
        <div className={styles.certificateContainer(isOpen)}>
          <Certificate {...restProps} style={style} />
        </div>
      </div>
    );
  };

  render() {
    return ReactDOM.createPortal(this.renderCertificatePreview(), this.certificateNode);
  }
}

export default CertificatePreview;
